<div class="challenge-deck-fullscreen" [ngClass]="{'vertical'  : vertical()}">
  <ghs-challenge-deck [deck]="deck" [fullscreen]="false" [vertical]="vertical()" (before)="beforeChallengeDeck($event)"
    (after)="afterChallengeDeck($event)">
  </ghs-challenge-deck>
  <div class="close-container" (click)="close()"></div>
</div>
<div class="close-container" (click)="close()"></div>